import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from '../utils/api';
import './AdminDashboard.css';

function SocialEditor() {
  const [, setSocial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    github: '',
    linkedin: '',
    instagram: '',
    email: ''
  });

  useEffect(() => {
    fetchSocial();
  }, []);

  const fetchSocial = async () => {
    try {
      const response = await axios.get('/content/simple-content?type=social');
      const data = response.data.data;
      setSocial(data);
      if (data) {
        setFormData({
          github: data.github || '',
          linkedin: data.linkedin || '',
          instagram: data.instagram || '',
          email: data.email || ''
        });
      }
    } catch (err) {
      setError('Failed to load social links');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSaving(true);

    try {
      await axios.put('/content/simple-content?type=social', formData);
      setSuccess('Social links updated successfully');
      fetchSocial();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update social links');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="text-center"><Spinner animation="border" /> Loading...</div>;
  }

  return (
    <div className="editor-card">
      <div className="editor-header">
        <h3>🔗 Edit Social Links</h3>
      </div>
      {error && <Alert variant="danger" className="alert-admin" dismissible onClose={() => setError('')}>{error}</Alert>}
      {success && <Alert variant="success" className="alert-admin" dismissible onClose={() => setSuccess('')}>{success}</Alert>}

      <Form onSubmit={handleSubmit} className="admin-form">
          <Form.Group className="mb-3">
            <Form.Label>GitHub URL</Form.Label>
            <Form.Control
              type="url"
              value={formData.github}
              onChange={(e) => setFormData({ ...formData, github: e.target.value })}
              placeholder="https://github.com/username"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>LinkedIn URL</Form.Label>
            <Form.Control
              type="url"
              value={formData.linkedin}
              onChange={(e) => setFormData({ ...formData, linkedin: e.target.value })}
              placeholder="https://www.linkedin.com/in/username"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Instagram URL</Form.Label>
            <Form.Control
              type="url"
              value={formData.instagram}
              onChange={(e) => setFormData({ ...formData, instagram: e.target.value })}
              placeholder="https://www.instagram.com/username"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="your@email.com"
            />
          </Form.Group>

          <Button className="btn-primary-admin" type="submit" disabled={saving}>
            {saving ? '💾 Saving...' : '💾 Save Changes'}
          </Button>
        </Form>
    </div>
  );
}

export default SocialEditor;

